import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { CardType, PaymentAccount, PaymentUtil } from '@uzurv/clara';
import { CardTypeConstants, DateFormatConstants } from '@uzurv/core';
import moment from 'moment-timezone';
import { LegacyFeatureFlagService } from 'projects/uzurv/src/services/legacy-feature-flag/legacy-feature-flag.service';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-organization-rider-payment-account-list-item',
  templateUrl: './organization-rider-payment-account-list-item.html',
  styleUrls: ['./organization-rider-payment-account-list-item.scss'],
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule]
})
export class OrganizationRiderPaymentAccountListItemComponent implements OnInit {
  @Input() paymentAccount: PaymentAccount;
  @Input() selected = false;
  @Output() edit: EventEmitter<PaymentAccount> = new EventEmitter();

  creditCardLogoSVG: string;

  isCreditCardValidationEnabled = false;

  constructor(private domSanitizer: DomSanitizer, private featureFlagService: LegacyFeatureFlagService) {}

  ngOnInit() {
    this.creditCardLogoSVG = PaymentUtil.getCreditCardLogoSVG(this.paymentAccount.cardType);

    this.isCreditCardValidationEnabled = this.featureFlagService.isCreditCardValidationEnabled();
  }

  get isUnverified(): boolean {
    if (!this.isExpired && this.isCreditCardValidationEnabled && !this.paymentAccount.verified) {
      return true;
    }

    return false;
  }

  get isExpired(): boolean {
    if (moment(this.paymentAccount.cardExpiration).isBefore(moment(), 'month')) {
      return true;
    }

    return false;
  }

  getHiddenCardNumberWithEnding(paymentAccount: PaymentAccount): SafeHtml {
    const cardTypeCode = paymentAccount?.cardType?.code;
    if (cardTypeCode === CardTypeConstants.CARD_TYPE_CODE_AMEX) {
      return this.domSanitizer.bypassSecurityTrustHtml(
        `****&emsp;&emsp;&emsp;&emsp;******&emsp;&emsp;&emsp;&emsp;*${paymentAccount.cardNumber}`
      );
    }
    return this.domSanitizer.bypassSecurityTrustHtml(
      `****&emsp;&emsp;&emsp;****&emsp;&emsp;&emsp;****&emsp;&emsp;&emsp;${paymentAccount.cardNumber}`
    );
  }

  formatCardExpiration(expiration: string): string {
    return moment(expiration).format(DateFormatConstants.CARD_EXPIRATION);
  }

  handleEditPaymentAccount(): void {
    this.edit.emit(this.paymentAccount);
  }
}
